import { Chip, Paper, Table, TableBody, TableCell, TableContainer, TableRow} from "@mui/material"
import Avatar from "../../Tools/Avatar"
import { useContext } from "react"
import UserContext from "../../../services/Context/UserContext"
import { txt } from "../../../services/translation"

export default function Affiliates({items}){

    const {user} = useContext(UserContext)

    return <TableContainer component={Paper} variant='outlined'>
        <Table>
            <TableBody>
                {items.map(a => 
                    <TableRow key={a.id}>
                        <TableCell width={40}>
                            <Avatar
                                initials={a.initials}
                                color={a.category?.color}
                            />
                        </TableCell>
                        <TableCell>
                            {a.name}
                        </TableCell>
                        <TableCell>
                            <Chip label={a.sponsor?.enrollments} sx={{mr: 1}} />
                            {txt('sponsoredPurchases')}
                        </TableCell>
                        {user.admin && 
                            <TableCell>
                                {(a.sponsor?.revenue || 0).toLocaleString()}<small>{txt('currencySymbol')}</small>
                            </TableCell>
                        }
                    </TableRow>    
                )}
            </TableBody>
        </Table>
    </TableContainer>
}